// utils/crypto/keyUtils.ts 

export async function computeKeyIdFromPublicPem(publicPem: string): Promise<string> {
  const cleaned = publicPem.replace(/-----(BEGIN|END) PUBLIC KEY-----|\s/g, "");
  const bin = Uint8Array.from(atob(cleaned), (c) => c.charCodeAt(0));
  const digest = await crypto.subtle.digest("SHA-256", bin);
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}
